import { useCommonWidgetHandlers } from './use-common-widget-handlers';
import AttributeWidget from '../../../editor/features/build/requestModels/widgets/AttributeWidget';

export const useAttributeWidgetHandlers = () => {
  const commonWidgetHandlers = useCommonWidgetHandlers();

  const addNew = (dialogueId: number, sortOrder: number) => {
    const newWidget = AttributeWidget.make(dialogueId, sortOrder);

    return commonWidgetHandlers.create(newWidget, dialogueId, sortOrder);
  };

  return {
    update: commonWidgetHandlers.update,
    addNew,
  };
};
